import { i18n } from '@shared/i18n';
import { GenericModel } from '@shared/model/generic-model';
import BooleanField from '@shared/fields/boolean-field';
import DateModelField from '@shared/fields/date-model-field';

function label(name) {
    return i18n(`entities.subprogram.fields.tryout.${name}`);
}

const fields = {
    exist: new BooleanField('exist', label('exist'), { required: true }),
    startDate: new DateModelField('startDate', label('startDate'), {
        "required": true,
        format: 'MMM Do',
    }),

    endDate: new DateModelField('endDate', label('endDate'), {
        "required": true,
        format: 'MMM Do',
    }),

}

export class SubprogramTryoutModel extends GenericModel {
    static get fields() {
        return fields;
    }
}